<script>
export default {
  name: 'GoogleMapMarkers',
  props: {
    markers: { type: Array, default: () => [] },
    userLocation: { type: Object, default: null },
    refObject: Object,
    pinColor: { default: '#016fb9' },
    // NOVO: ponto ativo vindo do pai
    activeCoord: { type: Object, default: null }
  },
  computed: {
    map () {
      return this.$parent.map
    },
    google () {
      return this.$parent.google
    }
  },
  data () {
    return { googleMarkers: [], userMarker: null, bounds: null }
  },
  watch: {
    // quando o pai mudar o ponto ativo, fazemos pan/zoom
    activeCoord (c) {
      if (!c) return
      this.panToPosition(c.lat, c.long)
    },
    // se a lista de markers mudar, refaz o fit
    markers: {
      deep: true,
      handler () {
        this._clearMarkers()
        this._placeMarkers()
        this.fitToMarkers()
      }
    }
  },
  methods: {
    panToPosition (lat, lng) {
      if (!(this.map && this.google)) return false
      if (typeof lat === 'string') lat = Number(lat.replace(',', '.'))
      if (typeof lng === 'string') lng = Number(lng.replace(',', '.'))

      const { LatLng } = this.google.maps
      const target = new LatLng(lat, lng)
      const currentCenter = this.map.getCenter()
      if (
        !currentCenter ||
        currentCenter.lat() !== lat ||
        currentCenter.lng() !== lng
      ) {
        this.map.panTo(target)
      }
      const curZoom = this.map.getZoom()
      if (curZoom < 16) this.map.setZoom(16)
      return true
    },

    _createUserMarkerIfNeeded () {
      if (
        !this.userLocation ||
        typeof this.userLocation.lat !== 'number' ||
        typeof this.userLocation.lng !== 'number'
      ) { return }
      if (this.userMarker) return
      const { Marker, LatLng } = this.google.maps
      this.userMarker = new Marker({
        position: new LatLng(this.userLocation.lat, this.userLocation.lng),
        icon: require('@/assets/icons/circle.svg'),
        map: this.map,
        clickable: true
      })
      if (this._bounds) this._bounds.extend(this.userMarker.getPosition())
    },

    _onMarkerClick (googleMarker) {
      this.$emit('marker-click', googleMarker)
      this.$parent.processMarkerClick(googleMarker)
    },

    _placeMarkers () {
      if (!(this.map && this.google)) return
      const svgMarker = {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: this.pinColor,
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 2
      }

      const { Marker, LatLng, LatLngBounds } = this.google.maps
      this._bounds = new LatLngBounds()

      this._createUserMarkerIfNeeded()

      this.markers.forEach((m) => {
        const lat = Number(String(m.lat).replace(',', '.'))
        const lng = Number(String(m.long).replace(',', '.'))
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return

        const googleMarker = new Marker({
          title: m.name,
          icon: svgMarker,
          position: new LatLng(lat, lng),
          map: this.map,
          refObject: this.refObject
        })
        googleMarker.addListener('click', () =>
          this._onMarkerClick(googleMarker)
        )
        this.googleMarkers.push(googleMarker)

        this._bounds.extend(googleMarker.getPosition())
      })
    },

    fitToMarkers () {
      if (!(this.map && this.google) || !this._bounds) return
      // só aplica fitBounds se houver ao menos 1 ponto
      try {
        this.map.fitBounds(this._bounds)
      } catch (_) {
        /* noop */
      }
    },

    _clearMarkers () {
      for (const mk of this.googleMarkers) {
        try {
          mk.setMap(null)
        } catch (_) {}
      }
      this.googleMarkers = []
      this._bounds = null
    }
  },
  mounted () {
    if (!(this.map && this.google)) return
    this._placeMarkers()
    this.fitToMarkers()

    // se já vier um activeCoord na montagem, foca nele depois do fit
    if (this.activeCoord) {
      // pequeno defer para após o fitBounds
      setTimeout(
        () => this.panToPosition(this.activeCoord.lat, this.activeCoord.long),
        0
      )
    }
  },
  beforeDestroy () {
    this._clearMarkers()
    if (this.userMarker) {
      try {
        this.userMarker.setMap(null)
      } catch (_) {}
      this.userMarker = null
    }
  },
  render () {
    return null
  }
}
</script>
